/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const packageSlice = createSlice({
    name: 'packageSlice',
    initialState: {
        confirmation: null,
    },
    reducers: {
        setConfirmation: (state, action) => {
            state.confirmation = action.payload;
        },
    },
});
export const { setConfirmation } = packageSlice.actions;

export default packageSlice.reducer;
